<template>
  <v-app class="imageBackground" :style="{ 'background-image': 'url(' + image + ')' }">
    <div class="login">
      <div class="form">
        <h2 class="form__title">{{ loginTitle }}</h2>
        <div class="form__error" v-if="!closeWarning">
          <div class="error__message">
            <p>{{ messageError }}</p>
            <span @click="closeWarning = !closeWarning">X</span>
          </div>
        </div>
        <div class="form__success" v-if="!closeSuccess">
          <div class="success__message">
            <p>{{ messageSuccess }}</p>
            <span @click="closeSuccess = !closeSuccess">X</span>
          </div>
        </div>

        <div class="infosForm" v-if="!salesChannelSelect">
          <form>
            <div class="rows">
              <input
                type="text"
                placeholder="Informe seu usuário"
                v-model="email"
                required
              />
            </div>
            <div class="rows">
              <div class="form-groups">
                <input
                  :type="[showPassword ? 'text' : 'password']"
                  v-model="senha"
                  placeholder="Informe sua senha"
                  required
                  @keyup.enter="login(email, senha)"
                />
                <span
                  class="input-group-text"
                  @click="showPassword = !showPassword"
                >
                  <i
                    :class="[showPassword ? 'fa fa-eye' : 'fa fa-eye-slash']"
                    aria-hidden="true"
                  ></i>
                </span>
              </div>
            </div>
            <a
              class="form__button"
              href="javascript:void(0)"
              @click="login(email, senha)"
              >Entrar</a
            >
          </form>
          <div class="form__options">
            <p>Esqueceu a senha? <a href="/recoverPassword">Recuperar Senha</a></p>
          </div>
        </div>
        <div v-else class="channel">
          <select class="input medium" id="saleChannel">
            <option
              v-for="(channel, index) in arraySalesChannel"
              :key="index"
              :value="channel.IdCanal"
            >
              {{ channel.NomeCanal }}
            </option>
          </select>
          <a
            class="form__button"
            href="javascript:void(0)"
            @click="continueToHome()"
            >Continuar</a
          >
        </div>
      </div>
    </div>
    <!-- Dialog -->
    <v-dialog v-model="loading.active" persistent width="300">
      <v-card color="var(--standardGreen)" dark>
        <v-card-text style="padding: 27px">
          <div v-html="loading.message"></div>
          <v-progress-linear
            style="margin-top: 15px"
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      email: "",
      senha: "",
      closeWarning: false,
      messageError: 'Usuário ou senha incorretos!',
      closeSuccess: false,
      messageSuccess: '',
      showPassword: false,
      linkDaPagina: null,
      arraySalesChannel: [],
      salesChannelSelect: false,
      loginTitle: "Entrar",
      dialog: {
        active: true,
        title: '',
        message: ''
      },
      loading:{
        active: false,
        message: null
      },
      image: null
    };
  },

  beforeCreate() {
    // Busca a imagem de Background
    axios.get(`https://www.leverosintegra.com.br/map/Api/SolarBanners`)
    .then(res => {
      this.image = res.data;
    })
    .catch(err => {
      alert(`Erro ao buscar imagem de fundo da página: ${err}`)
    })
  },

  async created() {
    this.linkDaPagina = window.location.href;

    // Valida query params do e-mail de recuperação de senha
    if (this.$route.query.sToken && this.$route.query.sCript) {
      // Envia requisição de atualização de senha
      axios({
        method: "get",
        url: `https://www.leverosintegra.com.br/map/Api/Authentication?sCript=${this.$route.query.sCript}&sToken=${this.$route.query.sToken}&recover=true`,
        // url: `http://localhost:54015/Api/Authentication?sCript=${this.$route.query.sCript}&sToken=${this.$route.query.sToken}&recover=true`,
      })
        .then((res) => {
          // Valida retorno da requisição
          if (res && res.data && res.data.status) {
            if (res.data.status === "ok") {
              let success = document.querySelector(".form__success");
              success.style.display = "block";
              this.messageSuccess = "Senha alterada com sucesso!"
              this.email = res.data.user;
            } else {
              let error = document.querySelector(".form__error");
              error.style.display = "block";
              this.messageError = "Token de recuperação de senha inválido!";
            }
          }
        })
        .catch((err) => {
          alert(`Acesso não autorizado, erro: ${err}`);
        });
    }
  },

  metaInfo() {
    return {
      title: "Entrar | Leveros Integra",
      meta: [
        {
          name: "description",
          content:
            "Acesse sua conta no Leveros Integra para vender e comprar, além de acesso a área restrita.",
        },
        { name: "robots", content: "index,follow" },
        { name: "country", content: "BRA" },
        { name: "currency", content: "R$" },
        { name: "author", content: "Leveros Integra" },
        { name: "copyright", content: "Leveros Integra" },
        {
          property: "og:title",
          content: "Entrar | Leveros Integra",
        },
        {
          property: "og:description",
          content:
            "Acesse sua conta no Leveros Integra para vender e comprar, além de acesso a área restrita.",
        },
        { property: "og:site_name", content: "Leveros Integra" },
        { property: "og:author", content: "Leveros Integra" },
        { property: "og:url", content: `${this.linkDaPagina}` },
        { property: "og:type", content: "company" },
      ],
      link: [{ rel: "canonical", href: `${this.linkDaPagina}` }],
    };
  },
  methods: {
    login(email, senha) {
      let error = document.querySelector(".form__error");
      error.style.display = "none";

      let success = document.querySelector(".form__success");
      success.style.display = "none";
      
      this.loading.message = "Buscando dados, aguarde..."
      this.loading.active = true;

      axios({
        method: "get",
         url: `https://www.leverosintegra.com.br/map/Api/Authentication?Usuario=${email}&Senha=${senha}`,
        //url: `http://localhost:54015/Api/Authentication?Usuario=${email}&Senha=${senha}`,
      })
      .then((res) => {
        this.loading.active = false;
        if (res.data.token != null) {
          localStorage.setItem("login", JSON.stringify(res.data));
          this.salesChannelOptions();
        } else {
          let error = document.querySelector(".form__error");
          error.style.display = "block";
          this.messageError = "Usuário ou senha incorretos!"
        }
      })
      .catch((err) => {
        this.loading.active = false;
        alert(`Acesso não autorizado, erro: ${err}`);
      });
    },
    salesChannelOptions() {
      this.loginTitle = "Seleção de canal de venda";
      this.salesChannelSelect = true;
      let dados = JSON.parse(localStorage.getItem("login"));
      this.arraySalesChannel = dados.canalvendas.filter(cv => cv.NomeCanal.toLowerCase().includes('solar -'));
    },
    continueToHome() {
      var saleChannel = document.getElementById("saleChannel").value;
      localStorage.setItem("saleChannel", saleChannel);

      // Tratativa - Parceiros do canal selecionado
      let dados = JSON.parse(localStorage.getItem("login"));
      if (dados.Parceiros && dados.Parceiros.length > 0) {
        // Filtra os parceiros por canal
        // dados.Parceiros = dados.Parceiros.filter(par => par.saleChannel === parseInt(saleChannel));
        // Atualiza localstorage
        localStorage.setItem("login", JSON.stringify(dados));
      }

      // Verifica se um canal é parte da Solar
      const objSale = this.arraySalesChannel.find(sale => sale.IdCanal === parseInt(saleChannel));
      const isSaleSolar = objSale.NomeCanal.toLowerCase().includes('solar');

      localStorage.setItem("isSaleSolar", isSaleSolar);

      var url_string = window.location.href;
      var url = new URL(url_string);
      var c = url.searchParams.get("urlCallBack");

      if (c != null) {
        window.location = c;
      } else {
        window.location = "/";
      }
    },
  },
  beforeMount() {
    axios.get(`https://www.leverosintegra.com.br/map/api/ip`).then((res) => {
      localStorage.setItem("ip", res.data[0]);
    });
  },
  mounted() {
    if (this.$route.query.Recuperacao) {
      let success = document.querySelector(".form__success");
      success.style.display = "block";
      this.messageSuccess = "E-mail de recuperação enviado com sucesso!"
    }
  }
};
</script>

<style lang="scss" scoped>

.imageBackground {
    // background:  no-repeat center center fixed;
    width: 100%;
    height: 100%;
    background-size: cover;
    position: absolute;
    top: auto;
}
.login {
  .image {
    width: 100%;
    height: 100%;
    background-size: cover;
    position: absolute;
    top: 0;
    z-index: -1;
  }

  .form {
    width: 30%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 10px;
    color: var(--customGray-500);
    background: var(--customWhite);
    border-radius: 5px;

    @media (max-width: 440px) {
      width: 90%;
    }

    &__title {
      color: var(--standardGreen);
      border-bottom: 1px solid var(--customGray-100);
      padding: 5px 0;
      font: 800 1.3rem "Soleto", sans-serif;
      margin-bottom: 15px;
    }

    &__error {
      display: none;

      .error {
        &__message {
          background: #ff000085;
          color: var(--customWhite);
          border-radius: 5px;
          padding: 5px !important;
          margin-bottom: 20px;
          display: flex;
          justify-content: space-between;
          font-size: 0.95rem;

          p {
            padding: 0;
            font-weight: bold;
          }

          span {
            cursor: pointer;
            font-weight: bold;
          }
        }
      }
    }

    &__success {
      display: none;

      .success {
        &__message {
          background: #4caf50;
          color: var(--customWhite);
          border-radius: 5px;
          padding: 5px !important;
          margin-bottom: 20px;
          display: flex;
          justify-content: space-between;
          font-size: 0.95rem;

          p {
            padding: 0;
            font-weight: bold;
          }

          span {
            cursor: pointer;
            font-weight: bold;
          }
        }
      }
    }

    label {
      padding: 0 0 5px 0;
      font-weight: bold;

      span {
        font: 500 0.95rem "Soleto", sans-serif;
      }
    }

    input {
      border-bottom: 1px solid var(--standardGreen);
      padding: 10px 0;
      width: 100%;
      font-size: 0.95rem;
      outline: none;

      &:focus {
        border-bottom: 2px solid var(--standardGreen);
      }

      &:-webkit-autofill {
        box-shadow: 0 0 0 30px white inset;
      }
    }

    &__button {
      background: var(--standardGreen);
      border-radius: 5px;
      color: var(--customWhite);
      padding: 10px;
      text-decoration: none;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      font: 700 1.1rem "Soleto", sans-serif;
      letter-spacing: 0.8px;
    }

    &__options {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding-top: 30px;

      p {
        font-size: 0.95rem;

        a {
          font-weight: bold;
          color: var(--standardGreen);
          text-decoration: none;
          font-size: 0.95rem;
        }
      }
    }
  }

  .channel {
    select {
      outline: none;
      margin-bottom: 15px;
    }
  }
}

.rows {
  display: flex;
  flex-direction: column;
  margin-bottom: 25px;
}

.form-groups {
  display: flex;
  align-items: center;
}

.input-group-text {
  position: absolute;
  right: 50px;
}

.input {
  border: 1px solid #a1a1a1;
  border-radius: 5px;
  padding: 10px;
  width: 100%;
  font-size: 0.875rem;
}
</style>